import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


export default function ConnectionStatus() {

    const [isOnline, setOnline] = useState(() => {
        return navigator.onLine
    })

    useEffect(() => {
        window.addEventListener('online', ()=> setOnline(true))
        window.addEventListener('offline', ()=> setOnline(false))

        return ()=>{
            window.removeEventListener('online', ()=> setOnline(true))
            window.removeEventListener('offline', ()=> setOnline(false))
        }
    })


    return (
        <>
            {!isOnline && (
                <Container fluid className='text-end small p-3 text-muted'>
                    Network status: <b>Offline</b> <FontAwesomeIcon className='ms-1' icon={'globe'} color={'red'} size={'lg'} fade />
                    <br/>
                    / <span role='button' className='link-primary small' onClick={() => window.location.reload(true)}>Refresh</span>
                </Container>
            )}
            {isOnline && (
                <></>
            )}
        </>
    );
};